/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isNone } from '@ember/utils';
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import NewsletterModel from 'cio/models/newsletter';
import TemplateModel from 'cio/models/template';
import { InAppRenderErrors } from 'cio/utils/previews';

interface PreviewerArgs {
  action: ActionModel;
  newsletter?: NewsletterModel;
  template: TemplateModel;

  isLoading?: boolean;
  showErrors: boolean;

  messageErrors: string[];
  previewErrors: InAppRenderErrors;
  recipientErrors: string[];
}

export default class ReviewErrors extends Component<PreviewerArgs> {
  get errors() {
    if (!this.args.showErrors) {
      return [];
    }

    let errors: InAppRenderErrors = { ...this.args.previewErrors };
    if (isNone(errors.to)) {
      errors.to = this.args.recipientErrors ?? [];
    }
    if (isNone(errors.body_json)) {
      errors.body_json = this.args.messageErrors ?? [];
    }
    if (isNone(errors.body_html)) {
      errors.body_html = this.args.messageErrors ?? [];
    }

    return errors;
  }
}
